import React from "react";
import "./HorizontalLoader.scss";

type Props = {
  size: "xs" | "md" | "lg" | "xl";
  color?: string;
};

const HorizontalLoader: React.FC<Props> = (props) => {
  const { size, color = "var(--background-opacity-tertiary-main)" } = props;

  return (
    <div className={`horizontal-loader size-${size}`}>
      <div className="bounce1" style={{ background: color }}></div>
      <div className="bounce2" style={{ background: color }}></div>
      <div className="bounce3" style={{ background: color }}></div>
    </div>
  );
};

export default HorizontalLoader;
